<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Packages / Plan</div>
                </div>
                <div class="col-md-3 offset-md-3 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill"
                            @click="create()">Create Plan</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover" :columns="plans.columns" :data="plans.data">
                    <template slot="table-row" v-if="plans.data.length">
                        <tr v-for="(item, index) in plans.data" :key="index" :class="{'inactive': !item.active}">
                            <td>{{item.name}}</td>
                            <td>{{item.description}}</td>
                            <td>{{item.startDate}}</td>
                            <td>{{item.endDate}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active === '1'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="view(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="edit(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
                                    <button v-if="item.active === '1'" class="btn btn-danger btn-sm" @click="statusChange(item, true)" v-tooltip.top-center="tooltips.delete"><i class="fa fa-toggle-off"></i></button>
                                    <button v-else class="btn btn-success btn-sm" @click="statusChange(item, false)" v-tooltip.top-center="tooltips.activate"><i class="fa fa-toggle-on"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const columns = ['Name', 'Description', 'Start Date', 'End Date', 'Status', 'Operations'];
    export default {
        name: 'Plans',
        components: {
            LTable,
        },
        data() {
        return {
            tooltips: {
                view: 'View',
                edit: 'Edit',
                delete: 'Inactivate',
                activate:'Activate',
            },
            plans: {
                columns: [...columns],
        data: []
    }
    }
    },
    methods: {
        fetch () {
            this.$store.dispatch('FETCH_PLANS')
                    .then((res) => {
                        this.plans.data = res;
                        console.log("this.plans.data : ", this.plans.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
        },
        view(selectedPlan){
            this.$store.commit('SET_SELECTED_PLAN', selectedPlan);
            this.$router.push({ name: 'Plan Details', params: { id:  selectedPlan.packageId}})
        },
        edit(selectedPlan){
            this.$store.commit('SET_SELECTED_PLAN', selectedPlan);
            this.$router.push({ name: 'Edit Plan', params: { id: selectedPlan.packageId}});
        },
        create(){
            this.$router.push({ name: 'Create Plan'})
        },
        statusChange(selectedPlan, boolean){
            console.log("selectedPlan : ", selectedPlan);
            this.$store.dispatch('DELETE_SELECTED_PLAN', {packageId: selectedPlan.packageId, isDelete: boolean})
                    .then((res) => {
                        console.log("DELETE_SELECTED_PLAN API res : ", res);
                        this.fetch();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_PLAN API error : ", err);
                    })
        }
    },
    created() {
        this.fetch();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plans/Plans.vue